export enum EHeatmapBaseFilterType {
  DATE_RANGE = 'date_range',
  URL_PATH = 'url_path',
  ANALYTIC_MODE = 'analytic_mode',
  /**
   * @deprecated
   */
  OPERATOR = 'operator',
}

export enum EHeatmapFilterType {
  VISITOR_JOURNEY = 'visitor_journey',
  MARKET = 'market',
  VISITOR_TYPE = 'visitor_type',
  TRAFFIC_SOURCE = 'traffic_source',
  PURCHASE_TYPE = 'purchase_type',
  TIME_ON_PAGE = 'time_on_page',
  ORDER_VALUE = 'order_value',
  CAMPAIGN = 'campaign_id',
  REFERRAL_SOURCE = 'referral_source',
}

export enum EVisitorJourneyOperator {
  THIS_PAGE_AND_FOLLOWING = 'THIS_PAGE_AND_FOLLOWING',
  THIS_PAGE_ONLY = 'THIS_PAGE_ONLY',
}

// ===========================
// URL Search Params Keys
// ===========================

export const FILTER_SEARCH_PARAM_KEYS = Object.values(EHeatmapFilterType);
export const BASE_FILTER_SEARCH_PARAM_KEYS = Object.values(EHeatmapBaseFilterType);
